export default __webpack_public_path__ + "static/media/JR_Consultores.b1988d58.svg";